import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { CreditCardIcon } from "lucide-react";
import ActivityContentWrapper from "./activity-content-wrapper";
import ActivityIconWrapper from "./activity-icon-wrapper";
import { ActivityItemHeader } from "./activity-item-header";
import ActivityWrapper from "./activity-wrapper";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@babackapp/ui/components/accordion";
import useFormatPrice from "@/hooks/use-format-price.ts";
import config from "@/config.ts";

type TransactionRefundedActivityProps = {
  activity: ReturnRequestLogDto;
};

type TransactionRefundedActivityValues = {
  accountId: string;
  amount: string;
  currency: string;
  lang: string;
  last4: string;
  origin: string;
  transactionId: string;
}

export default function TransactionRefundedActivity({
  activity,
}: TransactionRefundedActivityProps) {
  const t = useTranslation();
  const formatPrice = useFormatPrice()
  const transaction = activity.params as unknown as TransactionRefundedActivityValues;

  const testUri = config.isProd ? "" : "test/";
  const externalLink = `https://dashboard.stripe.com/${activity.params?.accountId}/${testUri}payments/${activity.params?.transactionId}`;

  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <CreditCardIcon className="size-4" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <div className="flex items-center gap-2">
          <Accordion type="single" collapsible>
            <AccordionItem value="item-1" className="border-0">
              <AccordionTrigger className="p-0">
                <ActivityItemHeader
                  title={t("returnDetail.transaction.refundedTitle", {
                    amount: formatPrice({
                      amount: parseFloat(transaction.amount),
                      currency: transaction.currency
                    })
                  })}
                  timestamp={activity.date}
                >
                </ActivityItemHeader>
              </AccordionTrigger>
              <AccordionContent>
                <div className="text-xs">
                  <div className="mt-1">{t("returnDetail.transaction.cardNumber")}: **** ****
                    **** {transaction.last4 || '****'}</div>
                  <div className="mt-1 mb-1">{t("returnDetail.transaction.cardHolder")}: {transaction.origin}</div>
                  <a
                    className="text-blue-500"
                    href={externalLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("returnDetail.transaction.externalLink")}
                  </a>
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
